var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 260,
    viewBox: "0 0 261 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_20_1679)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.724,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.224,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.192 76L167.159 165.99L131.051 176L95.0415 166.004L87.017 76H175.192Z",
    fill: "#264DE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.282 160.259L167.147 83.3591H131.104V168.348L160.282 160.259Z",
    fill: "#2965F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.413 116.74L106.402 127.779H131.105V116.74H105.413Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.105 94.3977H131.066H103.425L104.428 105.436H131.105V94.3977Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.104 156.893V145.408L131.056 145.421L118.762 142.102L117.976 133.298H112.003H106.895L108.442 150.63L131.054 156.907L131.104 156.893Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.659 127.779L143.378 142.095L131.066 145.418V156.902L153.696 150.63L153.862 148.765L156.456 119.704L156.725 116.74L158.718 94.3977H131.066V105.436H146.621L145.616 116.74H131.066V127.779H144.659Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_20_1679",
    x: 0.723999,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20_1679"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20_1679",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.729b9ac1e0ed5a9e7495711da2f168f7.svg";
export { ForwardRef as ReactComponent };